<template>
  <div>

    <!-- Header -->
    <div class="col-12">
      <h5
          class="bp_color"
          :style="isAccordion ? 'cursor:pointer;' : null"
          @click="isAccordion && (open = !open)"
      >
        <span v-if="isAccordion" style="margin-right:6px;">
          {{ open ? '▾' : '▸' }}
        </span>
        Additional Information
      </h5>
    </div>

    <!-- Body wrapper -->
    <div v-show="!isAccordion || open">

      <!-- Loading state -->
      <div
          v-if="loadingWebsiteUser"
          style="margin-left: 10px;"
          class="col-12 subtle-loading"
      >
        <i class="fas fa-spinner fa-spin mr-2"></i>
        Loading worker portal information…
      </div>

      <!-- Loaded content -->
      <div v-else>

        <section>
          <div class="col-12">
            <h5 style="font-size: 0.8rem; text-decoration: underline;">Website User</h5>
          </div>

          <div class="col-12">
            <template v-if="website_user">
              <ul>
                <li>This worker has created an account on our portal.</li>
                <li>User verified at {{ website_user.email_verified_at | formatDateTime }}.</li>
                <li>User last logged in {{ website_user.last_login | formatDateTime }}.</li>
              </ul>
            </template>

            <template v-else>
              The user has never logged in to the worker portal.
            </template>
          </div>
        </section>

        <section>
          <div class="col-12">
            <h5 style="font-size: 0.8rem; text-decoration: underline;">Declarations</h5>
          </div>

          <div class="col-12">
            <template v-if="website_user">
              <p>User formally made declarations on {{ website_user.created_at | formatDateTime }}:</p>

              <ul v-if="crmType === 'payroll'">
                <li>Contract for Services</li>
                <li>Data Protection & Privacy</li>
                <li>Conduct Regulations Opt Out Notice</li>
                <li>Sexual Harassment Policy</li>
              </ul>

              <ul v-if="crmType === 'recruitment'">
                <li>Contract for Services (PAYE &amp; CIS/Limited)</li>
                <li>Equal Opportunities Policy</li>
                <li>Data Protection Policy</li>
                <li>Eligibility to work in the UK</li>
                <li>Sexual Harassment Policy</li>
              </ul>
            </template>

            <template v-else>
              <p>The user has not formally made any declarations.</p>
            </template>
          </div>
        </section>

        <section v-if="worker.rel_services.recruitment">
          <div class="col-12">
            <h5 style="font-size: 0.8rem; text-decoration: underline;">Any Criminal Convictions:</h5>

            <p class="pt-0 mb-3">
              <span v-if="worker.rel_recruitment_info.any_criminal_convictions">Yes</span>
              <span v-else>No</span><br>

              <strong
                  v-if="worker.rel_recruitment_info.any_criminal_convictions"
                  style="display:inline-block;width:350px;"
              >
                Details:
              </strong>
              <span v-if="worker.rel_recruitment_info.any_criminal_convictions">
                {{ worker.rel_recruitment_info.criminal_convictions_details }}
              </span>
            </p>
          </div>
        </section>

      </div>
    </div>
  </div>
</template>




<script>
export default {
  name: "declarations",
  props: {
    worker: { required: true },
    files: { required: true },

    isAccordion: {
      type: Boolean,
      default: false
    },
    autoOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      open: this.autoOpen,
      website_user: null,
      loadingWebsiteUser: true
    };
  },
  async beforeMount() {
    try {
      const res = await axios.get(
          this.crmApiPath + 'worker/website/user_info/' + this.worker.id
      );

      if (res && res.status === 200 && typeof res.data !== 'string') {
        this.website_user = res.data;
      } else {
        this.website_user = null;
      }
    } catch (e) {
      this.website_user = null;

      if (e?.response?.status !== 500) {
        console.warn('worker website user_info failed', e);
      }
    } finally {
      this.loadingWebsiteUser = false;
    }
  },
  computed: {
    contract_file() {
      if (this.files.length > 0) {
        return this.files.filter(ft => ft.file_master_type_id === 8);
      }
      return [];
    }
  },
  methods: {
    view_file_modal(file_id) {
      this.$store.commit('SHOW_VIEW_FILE_MODAL', {
        id: file_id,
        type: 'worker'
      });
      this.$store.state.files.view_modal = true;
      this.$nextTick(() =>
          this.$root.$emit('bv::show::modal', 'view_file_modal')
      );
    }
  }
};


</script>

<style lang="scss" scoped>
.files_uploaded {
  padding-left: 30px;
  margin-bottom: 15px;

  button {
    display: inline-block;
    width: auto;
    margin-right: 20px;
  }

  .id_type {
    font-weight: bold;
    display: inline-block;
    width: 200px;
  }
}

.subtle-loading {
  font-size: 0.85rem;
  color: #777;
  padding: 8px 0;
}
</style>
